import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '5',
  label: 'Master Workbooks'
}, {
  value: '4',
  label: 'Expert Bonuses'
}, {
  value: '460+',
  label: 'Print-Ready Pages'
}, {
  value: '🌎',
  label: 'Available Worldwide'
}];
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-104" data-mp="4lywep65kkf8">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-105" data-mp="4jvwndf77cxb">
        <span className="mb-6 inline-block rounded-full border border-cobalt bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep" data-id="element-106" data-mp="128pg780q2n1x">
          The Complete Visual Chemistry Teaching System · 2026 Edition
        </span>

        <h1 className="font-serif-display text-[24px] font-bold leading-tight text-ink sm:text-5xl md:text-6xl" data-id="element-107" data-mp="nczvdd79wfys">
          Stop rebuilding your Chemistry lessons every single week. Get everything done — in under
          30 minutes.
        </h1>

        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-108" data-mp="384jpop0hb1o6">
          <div className="relative overflow-hidden rounded-[26px] bg-paper shadow-[0_20px_45px_-22px_rgba(31,36,48,0.28)]" data-id="element-109" data-mp="3j9265qny7uwl">
            <img src="https://cdn.magicpatterns.com/uploads/i5k3nQ7aTs8UR2tWQqj8JZ/mockuo_inicio_principal.webp" alt="Chemistry teacher holding the Visual Chemistry Master System box, with all 5 volumes on the shelf behind her" width="1365" height="768" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-110" data-mp="3o5j1b4tkf9j6" />
            <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-inset ring-white/45" aria-hidden="true" data-id="element-111" data-mp="2viy4vpy8g78r" />
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-cobalt-deep/80" data-id="element-112" data-mp="2hljb690y5daz">
            Everything printed, organized and ready for your very next class.
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-[12px] text-ink/70 sm:text-base" data-id="element-113" data-mp="nbl2wm6daiaz">
          The complete done-for-you Chemistry teaching system for High School teachers. 5 Master
          Workbooks. 4 Expert Bonuses. 460+ pages of print-ready, student-tested content. NGSS
          aligned. AP Chemistry compatible. Download it today. Use it Monday.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-114" data-mp="1b04cd515l14n">
          <CTAButton label="YES — I WANT THE COMPLETE SYSTEM" data-id="element-115" data-mp="161ayhbhyf83y" />
          <p className="mt-3 text-xs text-ink/60 sm:text-sm" data-id="element-116" data-mp="15zq0td0cf91v">
            Instant Access · Printable PDF · One-Time Payment · No Subscription
          </p>
          <p className="mt-2 text-xs font-medium text-cobalt-deep" data-id="element-117" data-mp="x031cwr6cdbg">
            💳 All major cards accepted worldwide · Secure checkout
          </p>
        </div>

        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-cobalt/30 bg-white sm:mt-9 sm:grid-cols-4" data-id="element-118" data-mp="3hrdbx2pxho3l">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-cobalt/20' : ''} ${index >= 2 ? 'border-t border-cobalt/20' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-119" data-mp="1x7hvvdunc30v" data-mpi={index}>
              <span className="font-serif-display text-4xl font-bold text-cobalt" data-id="element-120" data-mp="2g02iwennzdwr">
                {metric.value}
              </span>
              <span className="mt-1 text-xs font-medium text-ink sm:text-sm" data-id="element-121" data-mp="2kxkjnhrj2mto">{metric.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}